import React from 'react';

import './GameCard.style.scss';
import moment from "moment";
import Box from "@mui/material/Box";
import {FormattedMessage, useIntl} from "react-intl";
import {getLeagueByTeamId, getTeamLogoUrl} from "../../utils/SportUtils";
import GlobalConst from "../../constants/GlobalConst";
import {getStartTime} from "../../utils/timeUtils";

const GameCard = ({ game, isSelected, onSelect, gameCardRef }) => {

    const { locale } = useIntl();

    const gameLeague = GlobalConst.LEAGUES_BY_SPORT_ID[game.SportId];
    const awayTeamLogoUrl = getTeamLogoUrl(gameLeague, game.AwayTeamId, `${gameLeague}Player`,game.AwayTeamKey,null);
    const homeTeamLogoUrl = getTeamLogoUrl(gameLeague, game.HomeTeamId, `${gameLeague}Player`,game.HomeTeamKey,null);
    const isClosed = game.GL === 0;
    const isNotStarted = game.GL === 1 || game.Status === "scheduled";
    const isPlaying = game.GL % 1 > 0;

    const getTimeLabel = () => {
        if (isClosed) {
            return <FormattedMessage id="lobbyView.contests.customContest.gameInfos.final" />;
        }
        if (isNotStarted) {
            return getStartTime(moment(game.DateTime), locale);
        }
        if (isPlaying) {
            return <>
                <div className="live-icon"/>
                <div>{<FormattedMessage id="lobbyView.contests.customContest.gameInfos.live"/>}</div>
            </>;
        }
    };

    if (isClosed)
        return null;


    return (
        <Box ref={gameCardRef} className={`GameCard ${isSelected ? 'selected gold-gradient-border' : ''} ${isPlaying ? 'disabled' : ''}`} onClick={onSelect}>
            <div className="teamInfo">
                <div className={"homeTeam"}>
                    <div className="homeTeamContent">
                        <span className="homeTeamLogo" style={{backgroundImage: `url(${homeTeamLogoUrl})`}}/>
                        <span>{game.HomeTeamKey}</span>
                    </div>
                    <div>{game.HomeTeamScore}</div>
                </div>
                <div className={"awayTeam"}>
                    <div className='awayTeamContent'>
                        <span className="awayTeamLogo" style={{backgroundImage: `url(${awayTeamLogoUrl})`}}/>
                        <span>{game.AwayTeamKey}</span>
                    </div>
                    <div>{game.AwayTeamScore}</div>
                </div>
            </div>
            <div className="gameTime">{getTimeLabel()}</div>
        </Box>
    );
};

export default GameCard;
